import base from "../../baseurl";
import token from "../../getTk";

const Create = async (state) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Update = await api
    .post("frequentqas/create", {
      json: {
        question: state.Question,
        answer: state.answer,
        links: state.url.split(/\r?\n|,/),
        typeUuid: state.type,
      },
    })
    .json();

  return Update;
};

export default Create;
